module.exports = __webpack_public_path__ + "img/logo.39991862.svg";